<template>
  <div class="comp-tooltip">
    <slot><Icon v-if="icon" :name="icon" /></slot>
    <div v-if="content" class="overlay">
      <div v-html="content" />
      <div v-if="forReport || forState">
        <Icon v-if="forReport" name="fieldsSAV" />
        <Icon v-if="forState" name="fieldsState" />
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Tooltip',
    components: {
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      icon: {
        type: String,
        default: null,
      },
      content: {
        type: String,
        default: null,
      },
      forState: {
        type: Boolean,
        default: false,
      },
      forReport: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/animations';
@import '~scss/mixins';
@import '~scss/variables';

.comp-tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;

  & > svg {
    position: relative;
    top: 2px;
    width: 14px;
    height: 14px;
    color: $color-black-solid-100;
    user-select: none;
    pointer-events: none;
  }

  & > .overlay {
    position: absolute;
    display: none;
    bottom: 100%;
    left: 50%;
    width: 250px;
    transform: translate(-50%, 0);
    border: 1px solid $color-blue-solid-100;
    border-radius: 6px;
    box-shadow: $box-shadow-5;
    background-color: $color-white-solid-10;
    z-index: 5;

    & > div:first-of-type {
      position: relative;
      padding: 8px 10px;
      @include font-body-tiny-semibold;
    }

    & > div:nth-child(2) {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      top: 1px;
      left: -1px;
      padding: 8px;
      margin: 0;
      background-color: $color-blue-solid-100;
      border: 1px solid $color-blue-solid-100;
      width: calc(100% + 2px);
      min-height: 36px;
      border-radius: 0 0 6px 6px;

      & > svg {
        color: $color-white-solid-10;
        width: 24px;
        height: 24px;
        margin-right: 4px;
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }

  &:hover > .overlay {
    display: block;
    animation: fadein 0.3s ease forwards;
  }
}
</style>
